



















import { Component, Mixins, Model, Prop, Watch } from "vue-property-decorator";
import { capitalize } from "@apphq/utils";
import { I18NextMixin } from "../i18n";

/**
 * Select a file from the users local file system for upload
 *
 * The model contains a list of files, but currently only single file selection
 * is supported. So currently an array with a single element will be emitted.
 */
@Component
export default class FilesInput extends Mixins(I18NextMixin) {
  /** List of selected files */
  @Model("input", { type: Array, default: () => [] }) files!: Array<File>;
  /** Disable the input */
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  revision: number = 0;

  get preview() {
    return this.files && this.files.length
      ? this.files.map(file => file.name).join(", ")
      : capitalize(this.t("keine Datei ausgewählt"));
  }

  @Watch("files")
  onFilesUpdated(value: Array<File>) {
    if (!value || value.length === 0) {
      /** Reset input field */
      this.revision++;
    }
  }

  onFileSelect(event: { target: { files: Array<File> } }) {
    let files = [];
    for (const file of event.target.files) {
      files.push(file);
    }

    this.$emit("input", files);
  }
}
